import axios from 'axios';
import get from 'lodash/get';
import ldIsEmpty from 'lodash/isEmpty';
import queryString from 'query-string';
import { customAlphabet } from 'nanoid';
import dictionary from 'nanoid-dictionary';
import * as constants from 'common/constants';


export function isProduction() {
  if (process.env.NODE_ENV === 'production') {
    return true;
  } else {
    return false;
  }
}

export function isPreview() {
  if (typeof IS_PREVIEW !== 'undefined' && IS_PREVIEW) return true;
  return false;
}

export function isClientProduction() {
  if (isProduction() && !isPreview()) return true;
  return false;
}

export function getEcommercePlatform() {
  let ovData = window.OnVoardData;
  if (!ovData) return;
  return ovData.ecommerce_platform;
}

export function getPlatformIdentifierForEngagement() {
  let platform = getEcommercePlatform();
  if (platform === 'bigcommerce') return window.OnVoardData.store_hash;
  if (platform === 'easystore') return window.OnVoardData.shop.domain;
  if (platform === 'shopify' &&  window.OnVoardData) return window.OnVoardData.shop.myshopify_domain;
  if (platform === 'shopline') return window.Shopline.storeId;
  if (platform === 'shopware') return window.OnVoardData.app_shop_id;
  if (platform === 'wix') return window.OnVoardData.account_id;
  if (platform === 'woocommerce') return window.location.hostname;
  return;
}

export function isBrowser() {
  return typeof window !== 'undefined';
}

// https://stackoverflow.com/a/26824304/1446284
export function isInt(val) {
  var expression = /^[0-9]+$/;
  return expression.test(val);
}

// https://stackoverflow.com/a/9716488/1446284
export function isNumeric(val) {
  return !isNaN(parseFloat(val)) && isFinite(val);
}

export function isBoolean(value) {
  return typeof value === 'boolean';
}

export function isString(val) {
  return typeof val === 'string';
}

export function isFunction(val) {
  return typeof val === 'function';
}

export function isArray(val) {
  return Array.isArray(val);
}

export function isObject(val) {
  return (!!val) && (val.constructor === Object);
}

export function isEmpty(val) {
  return ldIsEmpty(val);
}

export function stringContains(string, subString) {
  return string.indexOf(subString) !== -1;
}

// Use jquery's `inArray` to check if value is in array.
// Will return boolean instead of value index
export function inArray(item, arrayList) {
  if ($.inArray(item, arrayList) !== -1) return true;
  return false;
}

export function loopObject(object, callback) {
  for (var k in object) {
    let v = object[k];
    callback(k, v);
  }
}

export function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

export function generateHash(length=16) {
  return [...Array(length)].map(() => Math.random().toString(36)[2]).join('');
}

export function formatAmount(amount) {
  amount = amount.toString();
  amount = amount.replace(/[^0-9.-]/g, '');
  amount = parseFloat(amount);
  return amount;
}

export function isMobileScreen() {
  if (!isBrowser()) return;
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  return screenWidth >= 768 ? false : true;
}

// In seconds precision
export function getCurrentTimestamp() {
  return Math.floor(Date.now() / 1000);
}

export function currentURL() {
  if (!isBrowser()) return;
  return window.location.href;
}

export function currentURLWithoutParams() {
  if (!isBrowser()) return;
  return window.location.protocol + '//' + window.location.host + window.location.pathname;
}

export function currentDomain() {
  if (!isBrowser()) return;
  return window.location.hostname;
}

export function currentURLPath() {
  if (!isBrowser()) return;
  return window.location.pathname;
}

export function getScrollPercent() {
  if (!isBrowser()) return;
  const h = document.documentElement;
  const b = document.body;
  const st = 'scrollTop';
  const sh = 'scrollHeight';
  return (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
}


export function appendQueryString(url, qs) {
  const parsed = queryString.parseUrl(url);
  qs = {...parsed.query, ...qs};

  Object.keys(qs).forEach((key) => (qs[key] === null || qs[key] === "") && delete qs[key]);
  let stringified = queryString.stringify(qs);
  if (!stringified) {
    return url;
  } else {
    return url + "?" + stringified;
  }
}

// {url: 'https://foo.bar', query: {foo: 'bar'}}
export function parseUrl(url) {
  return queryString.parseUrl(url);
}

// {foo: 'bar'}
export function parseQueryString(val) {
  return queryString.parse(val);
}

export function removeQueryString(url) {
  return url.split("?")[0];
}

// Scroll to top of element. Useful when you are using scrollable elements
export function scrollElementTop(el) {
  el.scrollTop = el.scrollHeight;

  setTimeout(() => {
    el.scrollTop = 0;
  }, 100);
}

export function getCssValueForSelector(selector, propKey) {
  if (!isBrowser()) return;
  const el = document.querySelector(selector);
  if (!el) return;

  style = window.getComputedStyle(el);
  return style.getPropertyValue(propKey);
}

export function attachUrlChangeEvent() {
  if (window.OV_ATTACHED_URL_CHANGE_EVENT) return null;

  let platform = getEcommercePlatform();

  // shopline need this to detect
  // https://phpcoder.tech/detect-url-change-in-javascript-without-refresh/
  if (platform === 'shopline') {
    let lastUrl = location.href;
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        window.dispatchEvent(new Event('ovurlchange'));
      }
    }).observe(document, {subtree: true, childList: true});

    window.OV_ATTACHED_URL_CHANGE_EVENT = 1;
    return;
  }

  // See https://stackoverflow.com/a/52809105/1446284
  history.pushState = (f => function pushState(){
    var ret = f.apply(this, arguments);
    window.dispatchEvent(new Event('pushstate'));
    window.dispatchEvent(new Event('ovurlchange'));
    return ret;
  })(history.pushState);

  history.replaceState = (f => function replaceState(){
    var ret = f.apply(this, arguments);
    window.dispatchEvent(new Event('replacestate'));
    window.dispatchEvent(new Event('ovurlchange'));
      return ret;
  })(history.replaceState);

  window.addEventListener('popstate', () => {
    window.dispatchEvent(new Event('ovurlchange'))
  });

  window.OV_ATTACHED_URL_CHANGE_EVENT = 1;
}

export function attachHashChangeEvent() {
  if (window.OV_ATTACHED_HASH_CHANGE_EVENT) return null;

  window.addEventListener('hashchange', () => {
    window.dispatchEvent(new Event('ovhashchange'))
  });

  window.OV_ATTACHED_HASH_CHANGE_EVENT = 1;
}

// See https://stackoverflow.com/a/43467144/1446284
export function isValidUrl(value) {
  if (!value) return false;
  if (value.startsWith("//")) value = value.replace("//", "https://");
  if (!value.startsWith("http://") && !value.startsWith("https://")) {
    value = `http://${value}`
  }

  let url;
  try {
    url = new URL(value);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
}

// https://gist.github.com/ManUtopiK/469aec75b655d6a4d912aeb3b75af3c9
export function cleanGraphQLResponse(input) {
  if (!input) return null
  const output = {}
  const isObject = obj => {
    return obj !== null && typeof obj === 'object' && !Array.isArray(obj)
  }

  Object.keys(input).forEach(key => {
    if (input[key] && input[key].edges) {
      output[key] = input[key].edges.map(edge =>
        cleanGraphQLResponse(edge.node)
      )
    } else if (isObject(input[key])) {
      output[key] = cleanGraphQLResponse(input[key])
    } else if (key !== '__typename') {
      output[key] = input[key]
    }
  })

  return output
}


const requestAnimFrame = (function() {
  if (window.requestAnimationFrame) return window.requestAnimationFrame;
  return (callback, element) => window.setTimeout(callback, 1000 / 60);
})();

// See https://gist.github.com/joelambert/1002116
export function requestInterval(fn, delay) {
  if(!window.requestAnimationFrame) return window.setInterval(fn, delay);

  let start = new Date().getTime();
  let handle = new Object();

  function loop() {
    var current = new Date().getTime(),
      delta = current - start;

    if(delta >= delay) {
      fn.call();
      start = new Date().getTime();
    }

    handle.value = requestAnimFrame(loop);
  };

  handle.value = requestAnimFrame(loop);
  return handle;
}


// See https://gist.github.com/joelambert/1002116
export function clearRequestInterval(handle) {
  if (window.cancelAnimationFrame) window.cancelAnimationFrame(handle.value);
  clearInterval(handle);
}

export function stringifyError(error) {
  try {
    error = JSON.stringify(error);
  } catch {}
  return error;
}

export function printErrors(errors) {
  if (isArray(errors)) {
    errors.forEach((error) => {
      console.log(error);
    });

    return;
  }

  if (isObject(errors)) {
    for (let [key, value] of Object.entries(errors)) {
      console.log(`${key}: ${value}`);
    }

    return;
  }

  console.log(errors);
}


//===================================================
// interceptRequests
//===================================================
// https://gist.github.com/sergeimuller/a609a9df7d30e2625a177123797471e2
function replaceXHROpen(interceptPaths, callback) {
  let oldXHROpen = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
   this.addEventListener('load', function() {
      if (!interceptPaths.some((path) => url.includes(path))) return;

      // Can't guarantee response is always json
      callback(this.response, url);
   });

   oldXHROpen.apply(this, arguments);
  }

  // required because some apps or themes mess jQuery up and causing unexpected issues
  try {
    if (window.jQuery) {
      jQuery(document).ajaxSuccess(function(event, xhr, settings) {
        if (!interceptPaths.some((path) => settings.url.includes(path))) return;

        // Can't guarantee response is always json
        callback(xhr.responseText, settings.url);
      });
    }
  } catch(e) {}
}

// https://stackoverflow.com/a/64961272/1446284
function replaceFetch(interceptPaths, callback) {
  let oldFetch = window.fetch;
  window.fetch = async (...args) => {
    const reqUrl = args[0];
    const response = await oldFetch(...args);
    if (!reqUrl || !interceptPaths.some((path) => reqUrl.includes(path))) return response;

    // Can't guarantee response is always json
    response
      .clone()
      .text()
      .then((textResponse) => {
        callback(textResponse, reqUrl);
      })
      .catch((err) => {
        console.error(err);
      })

    return response;
  }
}


export function interceptRequests(interceptPaths, callback) {
  if (getEcommercePlatform() === 'shopline' && window.__AJAX_INTERCEPTOR__) {
    window.__AJAX_INTERCEPTOR__((data) => {
        if (data.method !== 'GET') return;
        if (!interceptPaths.some((path) => data.url.includes(path))) return;

        // Can't guarantee response is always json
        callback(data.xhr.responseText, data.url);
    });
  }

  replaceXHROpen(interceptPaths, callback);
  replaceFetch(interceptPaths, callback);
}


//===================================================
// API Utils
//===================================================
export function handleErrorCallback(error, errorCallback) {
  if (error.response) {
    if (error.response.status === 500) {
      errorCallback("Server error 500. This error indicates that there are some issues on our end.");
      return;
    }

    if (error.response.data) {
      if (error.response.data.errors && Array.isArray(error.response.data.errors)) {
        errorCallback(error.response.data.errors.join("\n"));
        return;
      }

      errorCallback(error.response.data);
      return;
    }
  }

  errorCallback(error.message);
}

export function handleRqSuccess(response, successCallback) {
  successCallback(response.data);
};


export function handleRqError(error, errorCallback) {
  handleErrorCallback(error, errorCallback);
};


export function getRq(kwargs) {
  const config = {};
  config['method'] = 'get';
  config['url'] = kwargs.url;
  if (kwargs.headers) config['headers'] = kwargs.headers;

  axios(config)
    .then((response) => handleRqSuccess(response, kwargs.successCallback))
    .catch((error) => handleRqError(error, kwargs.errorCallback));
};

export function postRq(kwargs) {
  const config = {};
  config['method'] = 'post';
  config['url'] = kwargs.url;
  config['data'] = kwargs.data || "{}";
  if (kwargs.headers) config['headers'] = kwargs.headers;

  axios(config)
    .then((response) => handleRqSuccess(response, kwargs.successCallback))
    .catch((error) => handleRqError(error, kwargs.errorCallback));
};

export function buildUrl(path, qs={}) {
  return appendQueryString(`${BASE_API_URL}/${constants.API_VERSION}/${path}`, qs);
}

export function uniqueId(prefix='', length=16) {
  const generator = customAlphabet(dictionary.alphanumeric, length);
  let id = generator();
  if (prefix) id = `${prefix}${id}`;
  return id;
}

// https://github.com/scopsy/await-to-js
export function to(promise) {
  return promise.then(data => {
    return [null, data];
  })
  .catch(err => [err]);
}
